import _ from 'lodash';
import ContextNames from './context_names';

/**
 * Creates a basic action class for blocking add
 * @param EntityClass - the class of entity being added
 * @param create(attrs)              - Entity factory, if not specified `EntityClass.create` will be used
 * @param asDto(entity)              - Entity-to-DTO converter
 * @returns a class for entity add action
 */
export default function createAddAction(EntityClass, { create, asDto }) {
  let { storeName, gatewayName } = ContextNames.fromModelClass(EntityClass);

  return class {
    constructor(context) {
      this.context = context;
    }

    run(attrs) {
      if (this._store.isPendingNew()) {
        return;
      }

      _.forEach(attrs, function(value, key) {
        if (typeof value === 'string') {
          attrs[key] = value.trim();
        }
      });

      let validationErrors = this._getValidationErrors(attrs);
      if (validationErrors.length) {
        this._store.setErrorsForNew(validationErrors);
      } else {
        let entity = create ? create(attrs) : EntityClass.create(attrs);
        this._store.setPendingNew(entity);
        this.context.gateways[gatewayName].add(asDto(entity));
      }

      if (this.after) {
        this.after(attrs, validationErrors);
      }
    }

    get _store() {
      return this.context.stores[storeName];
    }

    /**
     * Returns validation errors for the specified attributes.
     * @returns an array of Err objects or an empty array if there were no errors.
     *
     * Override in subclasses if validation rules are different or need to be extended.
     */
    _getValidationErrors(attrs) {
      throw new Error('_getValidationErrors not implemented');
    }
  };
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/lib/create_add_action.js